import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { CSSTransition } from "react-transition-group";
import "./styles.css";

const Modal = (props) => {
  const closeOnEscapeKeyDown = (e) => {
    if ((e.charCode || e.keyCode) === 27) {
      props.onClose();
    }
  };

  useEffect(() => {
    document.body.addEventListener("keydown", closeOnEscapeKeyDown);
    return function cleanup() {
      document.body.removeEventListener("keydown", closeOnEscapeKeyDown);
    };
  });

  return ReactDOM.createPortal(
    <CSSTransition
      in={props.show}
      unmountOnExit
      timeout={{ enter: 0, exit: 300 }}
    >
      <div className="modal" onClick={props.onClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <div
            className="modal-header"
            style={{
              backgroundColor: "var(--primary-color)",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <h4 className="modal-title" style={props?.titleStyle ?? {}}>
              {props.title}
            </h4>
            <h4
            onClick={props.onClose}
              className="modal-title"
              style={{
                color: "white",
                fontFamily: "sans-serif",
                cursor: "pointer",
              }}
            >
              x
            </h4>
          </div>
          <div className="modal-body">{props.children}</div>
          <div className="modal-footer">
            {!!props.actions ? props.actions : <button onClick={props.onClose} className="button">
              Close
            </button>}
            
          </div>
        </div>
      </div>
    </CSSTransition>,
    document.getElementById("root")
  );
};

export default Modal;
